import React, { useState, useEffect } from 'react';
import { portfolioData, uiStates } from '../data/portfolioData';
import Navigation from './Navigation';
import HeroSection from './HeroSection';
import MainSection from './MainSection';
import { useColorTheme } from '../hooks/useColorTheme';

const Portfolio = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  // 테마는 모든 페이지가 함께 쓰고 기억한다(페이지를 옮겨도 유지, CLAUDE.md Phase 22)
  const { colorTheme, systemDarkMode, currentTheme, toggleColorTheme } = useColorTheme();

  useEffect(() => {
    const checkScreenSize = () => {
      const width = window.innerWidth;
      setIsMobile(width <= 640);
      setIsTablet(width > 640 && width <= 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // 테마별 배경 클래스 - 배경 투명하게 (히어로 이미지가 보이도록)
  const getBackgroundClass = () => {
    return "min-h-screen w-full max-w-full overflow-x-hidden";
  };

  return (
    <div className={getBackgroundClass()}>
      {/* Full Screen Background Hero Image — HeroSection 이 이 상자의 크기로 사진 속 랩탑 화면 위치를 계산한다(id 를 바꾸지 말 것, CLAUDE.md Phase 20) */}
      <div id="hero_background" className="fixed inset-0 w-full h-full -z-10">
        <img
          src="/background-hero.png"
          alt="햇빛이 드는 따뜻한 개발 작업 환경"
          className="w-full h-full object-cover"
        />
      </div>

      {/* Navigation */}
      <Navigation 
        navigation={portfolioData.navigation}
        isMobile={isMobile}
        personal={portfolioData.personal}
        colorTheme={colorTheme}
        currentTheme={currentTheme}
        systemDarkMode={systemDarkMode}
        toggleColorTheme={toggleColorTheme}
      />
      
      {/* Main Content - 와이어프레임에 맞춰 구현 */}
      {/* 데스크탑: 오른쪽 고정 사이드바 폭(--desktop-nav-width)만큼 본문을 비워 겹치지 않게 한다 (Phase 7) */}
      <main
        className={`w-full max-w-full overflow-x-hidden ${isMobile ? 'pb-20' : ''}`}
        style={isMobile ? undefined : { paddingRight: 'var(--desktop-nav-width)' }}
      >
        {/* Hero + Main Combined Section */}
        <section className={`min-h-screen flex items-center justify-center pt-4 w-full max-w-full overflow-x-hidden ${
          !isMobile ? '' : ''
        }`} style={isMobile ? {
          paddingLeft: '12px',
          paddingRight: '12px'
        } : isTablet ? {
          paddingLeft: 'calc(100vw / 7 + 16px - 4rem)',
          paddingRight: 'calc(100vw / 7 + 16px + 17px - 4rem)' // 스크롤바 너비 17px 보정 - 4rem
        } : {
          paddingLeft: 'calc(100vw / 7 + 16px - 4rem)',
          paddingRight: 'calc(100vw / 7 + 16px + 17px - 4rem)' // 스크롤바 너비 17px 보정 - 4rem
        }}>
          <div className="max-w-6xl mx-auto w-full">
            <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 xl:gap-40 items-center">
              {/* Main Section - Left */}
              <div className="order-2 lg:order-1">
                <MainSection personal={portfolioData.personal} currentTheme={currentTheme} />
              </div>
              
              {/* Hero Section - Right */}
              <div className="order-1 lg:order-2">
                <HeroSection typingTexts={uiStates.typingTexts} currentTheme={currentTheme} />
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Portfolio;